import { DynamicTable } from '@Components/General/DynamicTable';
import { EmailField } from '@Components/General/DynamicTable/Cells';
import InfiniteScroll from '@Components/General/InfiniteScroll';
import useSidePan from '@hooks/useSidePan';
import { Card, CardContent, CardHeader, TableBody } from '@mui/material';
import { useSuspenseQuery } from '@tanstack/react-query';
import { useParams } from '@tanstack/react-router';
import { emailStatsQueryOptions } from '@utils/queryOptions';
import { t } from 'i18next';
import { useTranslation } from 'react-i18next';

const statuses = [
    'sent',
    'delivered',
    'opened',
    'clicked',
    'unsubscribed',
    // 'complaints',
    // 'bounced',
];

const eventTypes = {
    PENDING: 0,
    SENT: 1,
    FAILED: 2,
    REJECTED: 3,
    RECEIVED: 4,
    OPENED: 5,
    CLICKED: 6,
    SPAM: 7,
};

const statTypes = {
    sent: {
        title: 'Sent',
        columns: [],
    },
    delivered: {
        title: 'Delivered',
        columns: [],
    },
    opened: {
        title: 'Opened',
        columns: [],
    },
    clicked: {
        title: 'Clicked',
        columns: [],
    },
    failed: {
        title: 'Failed',
        columns: [{ name: t('Failure'), field: 'note' }],
    },
    bounced: {
        title: 'Bounced',
        columns: [{ name: t('Bounce Reason'), field: 'note' }],
    },
    spam: {
        title: 'Spam',
        columns: [{ name: t('Note'), field: 'note' }],
    },
    unsubscribed: {
        title: 'Unsubscribed',
        columns: [],
    },
};

const EmailStats = () => {
    const { t } = useTranslation();
    const { statType, emailId } = useParams({});
    const { data } = useSuspenseQuery(
        emailStatsQueryOptions(emailId, statType),
    );

    const openSidePan = useSidePan();

    return (
        <Card sx={{ flex: 1 }}>
            <CardHeader
                title={t('emailStats.' + statTypes[statType].title)}
                // avatar={<GroupsRounded />}
            />
            <CardContent>
                <DynamicTable
                    TableBodyComponent={InfiniteScroll}
                    tableBodyProps={{
                        ListComponent: TableBody,
                        hasMore: false,
                    }}
                    columns={[
                        { name: t('Name'), field: 'display_name' },
                        {
                            name: t('Email'),
                            field: 'emails',
                            Component: EmailField,
                        },
                        {
                            name: t('emailEvent.Time'),
                            field: 'timestamp',
                            renderField: row =>
                                row.timestamp?.toLocalRegularDateTime(),
                        },
                        ...statTypes[statType].columns,
                    ]}
                    rows={data}
                    rowProps={row =>
                        row?.contact_id && {
                            onClick: () =>
                                openSidePan({ contactId: row?.contact_id }),
                        }
                    }
                />
            </CardContent>
        </Card>
    );
};

export default EmailStats;
